<template>
  <!-- Top Up Modal -->
  <div class="modal fade" id="topUpModal" tabindex="-1" role="dialog" aria-labelledby="topUpModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="topUpModalLabel">Top Up Business</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <!-- Alert Message -->
          <div class="alert alert-warning" role="alert">
            Please enter the correct items that should have been invoiced for the business to continue.
          </div>

          <!-- Business Information -->
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="form-group">
                <label>Business Name</label>
                <input type="text" class="form-control" :value="businessDetails.businessName" readonly>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Business Number</label>
                <input type="text" class="form-control" :value="businessDetails.businessID" readonly>
              </div>
            </div>
          </div>

          <!-- Location Information -->
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="form-group">
                <label>Sub County</label>
                <select class="form-control" v-model="selectedSubCounty" @change="handleSubCountyChange">
                  <option value="">Select Sub County</option>
                  <option v-for="s in subCounties" :key="s.subCountyID" :value="s.subCountyID">
                    {{ s.subCountyName }}
                  </option>
                </select>

                <!-- Pre-selected value display -->
                <small class="text-muted" v-if="businessDetails.subCountyName">
                  Current: {{ businessDetails.subCountyName }}
                </small>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Ward</label>
                <select class="form-control" v-model="selectedWard" :disabled="!wards.length">
                  <option value="">Select Ward</option>
                  <option v-for="w in wards" :key="w.wardID" :value="w.wardID">
                    {{ w.wardName }}
                  </option>
                </select>
                <!-- Pre-selected value display -->
                <small class="text-muted" v-if="businessDetails.wardName">
                  Current: {{ businessDetails.wardName }}
                </small>
              </div>
            </div>
          </div>

          <!-- Business Category -->
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="form-group">
                <label>Business Category</label>
                <select class="form-control" v-model="selectedCategory" @change="handleCategoryChange">
                  <option value="">Select Category</option>
                  <option v-for="type in incomeTypes" :key="type.incomeTypeId" :value="type.incomeTypeId">
                    {{ type.incomeTypeDescription }}
                  </option>
                </select>
                <!-- Pre-selected value display -->
                <small class="text-muted" v-if="businessDetails.businessCategory">
                  Current: {{ businessDetails.businessCategory }}
                </small>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Business Sub Category</label>
                <select class="form-control" v-model="selectedSubCategory" :disabled="!feesAndChargess.length">
                  <option value="">Select Sub Category</option>
                  <option v-for="fee in feesAndChargess" :key="fee.feeId" :value="fee.feeId">
                    {{ fee.feeDescription }} - KES {{ fee.unitFeeAmount }}
                  </option>
                </select>
                <!-- Pre-selected value display -->
                <small class="text-muted" v-if="businessDetails.businessSubCategory">
                  Current: {{ businessDetails.businessSubCategory }}
                </small>
              </div>
            </div>
          </div>

          <!-- Other Applicable Charges -->
          <div class="row mb-3" v-if="feesAndChargesOthers && feesAndChargesOthers.length > 0">
            <div class="col-12">
              <h6>OTHER APPLICABLE CHARGES (-- SELECT WHERE APPLICABLE. ---)</h6>
              <div class="table-responsive">
                <table class="table table-sm">
                  <thead>
                  <tr>
                    <th width="50">Select</th>
                    <th>Description</th>
                    <th>Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="charge in feesAndChargesOthers" :key="charge.feeId">
                    <td>
                      <input type="checkbox" v-model="selectedCharges" :value="charge">
                    </td>
                    <td>{{ charge.feeDescription }}</td>
                    <td>KES {{ charge.unitFeeAmount }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Total -->
          <div class="row">
            <div class="col-12">
              <div class="alert alert-info">
                <strong>TOTAL: KES {{ calculateTotal() }}</strong>
              </div>
            </div>
          </div>

          <!-- Computed Amount -->
          <div class="row" v-if="billCreated">
            <div class="col-12">
              <div class="alert alert-success">
                <h5>Invoice Created Successfully!</h5>
                <p>Bill Number: {{ newBillNo }}</p>
                <button @click="$emit('print-bill', newBillNo)" class="btn btn-primary btn-sm">
                  <i class="bx bx-printer me-2"></i> Print Invoice
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary" @click="submitTopUp" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
            {{ loading ? 'Processing...' : 'NEXT' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopUpModal",
  props: {
    businessDetails: {
      type: Object,
      default: () => ({})
    },
    billDetails: {
      type: Object,
      default: () => ({})
    },
    subCounties: {
      type: Array,
      default: () => []
    },
    wards: {
      type: Array,
      default: () => []
    },
    incomeTypes: {
      type: Array,
      default: () => []
    },
    feesAndChargess: {
      type: Array,
      default: () => []
    },
    feesAndChargesOthers: {
      type: Array,
      default: () => []
    },
    feesAndCharges: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    billCreated: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedSubCounty: '',
      selectedWard: '',
      selectedCategory: '',
      selectedSubCategory: '',
      selectedCharges: [],
      newBillNo: '',
      total: 0
    };
  },
  watch: {
    businessDetails: {
      handler(newVal) {
        // Pre-populate fields when business details change
        if (newVal) {
          this.selectedSubCounty = newVal.subCountyID || '';
          this.selectedWard = newVal.wardID || '';
          this.selectedCategory = newVal.incomeTypeID || '';
          this.selectedSubCategory = newVal.feeID || '';

          // Trigger loading of related data
          if (this.selectedSubCounty) {
            this.$emit('get-wards', this.selectedSubCounty, newVal.subCountyName);
          }
          if (this.selectedCategory) {
            this.$emit('get-fees-and-charges', this.selectedCategory);
          }
        }
      },
      deep: true,
      immediate: true
    },

    // Auto-select sub-category when fees are loaded
    feesAndChargess: {
      handler(newFees) {
        // If fees are loaded and we have a feeID from businessDetails, auto-select it
        if (newFees && newFees.length > 0 && this.businessDetails.feeID) {
          const currentFeeId = this.businessDetails.feeID;
          const feeExists = newFees.find(fee => fee.feeId === currentFeeId);

          if (feeExists) {
            this.selectedSubCategory = currentFeeId;
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleSubCountyChange() {
      const selected = this.subCounties.find(
          s => String(s.subCountyID) === String(this.selectedSubCounty)
      );
      if (selected) {
        this.$emit('get-wards', this.selectedSubCounty, selected.subCountyName);
      }
    },

    handleCategoryChange() {
      if (this.selectedCategory) {
        this.$emit('get-fees-and-charges', this.selectedCategory);
      }
    },


    calculateTotal() {
      let total = 0;

      // Add main fee
      if (this.selectedSubCategory) {
        const mainFee = this.feesAndChargess.find(f => f.feeId === this.selectedSubCategory);
        if (mainFee) {
          total += parseFloat(mainFee.unitFeeAmount) || 0;
        }
      }

      // Add selected charges
      this.selectedCharges.forEach(charge => {
        total += parseFloat(charge.unitFeeAmount) || 0;
      });

      this.total = total;
      return total.toFixed(2);
    },

    submitTopUp() {
      // Prepare data for submission
      const topUpData = {
        businessID: this.businessDetails.businessID,
        subCountyID: this.selectedSubCounty,
        wardID: this.selectedWard,
        incomeTypeID: this.selectedCategory,
        feeID: this.selectedSubCategory,
        otherCharges: this.selectedCharges,
        total: this.total
      };

      this.$emit('update-business-top-up', topUpData);
    }
  }
}
</script>


<style scoped>
.modal-lg {
  max-width: 800px;
}

.table-responsive {
  max-height: 300px;
  overflow-y: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.text-muted {
  font-size: 0.875rem;
}
</style>